module.exports = __webpack_public_path__ + "images/category_lp/tablet/store_images/1_ac751538dbf47c700e660a813aad4206.jpg";